/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useCookies } from '@brochure/globals';

import Hero from '../../components/Hero';
import Invoice2goFaq from '../../components/Invoice2goFaq';
import Layout from '../../components/Layout';
import MainContent from '../../components/MainContent';
import PlpContext from './context';
import SEO from '../../components/Seo';
import '../../styles/master.css';
import '../../styles/buttons.css';
import '../../styles/footer.css';
import '../../styles/header.css';
import '../../styles/plp.css';
import '../../styles/homepage-clone.css';
import '../../styles/legacy-plp.css';
import '../../styles/jquery.ui.css';
import '../../fonts/font-awesome/css/font-awesome.css';
import '../../styles/style.css';

const Plp = ({ pageContext, plpPreview = null }) => {
  const plp = plpPreview || pageContext;
  plp.plp.channelurl = plp.plp.channelurl || '/app';

  useCookies(plp);

  return (
    <PlpContext.Provider value={plp}>
      <SEO plp={plp} />
      <Helmet>
        <body className="plp-layout" />
      </Helmet>
      <Layout>
        <main id="main">
          <div id="fb-root" />
          {plp.plp.coBrandedLogo && (
            <div className="sub-nav-logo">
              <img src={plp.plp.coBrandedLogo.sourceUrl} />
            </div>
          )}
          <Hero plp={plp} />
          {// plpId 26753 refers to invoice2go
          plp.plpId === 26753 && <Invoice2goFaq />}
          <MainContent />
        </main>
      </Layout>
    </PlpContext.Provider>
  );
};

const plpShape = PropTypes.shape({
  plp: PropTypes.shape({
    actionUrl: PropTypes.string,
    backgroundImage: PropTypes.shape({
      sourceUrl: PropTypes.string,
    }),
    channelurl: PropTypes.string,
    coBrandedLogo: PropTypes.shape({
      sourceUrl: PropTypes.string,
    }),
    customContactNumber: PropTypes.string,
    heroparagraph: PropTypes.string,
    leadHeroTitle: PropTypes.string,
  }),
  link: PropTypes.string,
  plpId: PropTypes.number,
  uri: PropTypes.string,
});

Plp.propTypes = {
  pageContext: plpShape,
  plpPreview: plpShape,
};

export default Plp;
